import * as yup from 'yup'

export const validateStatusDialog = yup.object().shape({
  cenarioId: yup
    .string()
    .nullable()
    .when('$validateCenario', {
      is: true,
      then: schema => schema.required('Obrigatório')
    })
})
